import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=18c1d1c4&"
import script from "./metadata.vue?vue&type=script&lang=js&"
export * from "./metadata.vue?vue&type=script&lang=js&"
import style0 from "./metadata.vue?vue&type=style&index=0&id=18c1d1c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports